// Functionality for working with smart contract schemas. This uses the WASM at entrypoint `@concordium/rust-bindings/dapp`.
export * from '../schema.js';
export * from '../schemaTypes.js';
